const getStepData = (stepData, step) =>
  stepData && stepData.find(({ stepName }) => stepName === step);

export default getStepData;
